import { PrimaryButton, Table, Tooltip } from '@shape-ds/components';
import {
  handleVibrationAnalysisSave,
  getSelectedVibrationCells,
  ExtendedVibrationTable,
} from 'components/Evidences/Helpers/helper';
import './AttachVibrationAnalysisTable.scss';
import { useTranslation } from 'react-i18next';
import { useVibrationAnalysisColumns } from './useVibrationAnalysisColumns';
import { NoData } from 'pages/Asset/tabs/Cases/components/NoData/NoData';
import { AddCircleOutlineOutlined } from '@mui/icons-material';
import { useVibrationAnalysisMutation } from 'queries/externalReferences/queries';

type VibrationAnalysisData = {
  period: string;
  filteredData: ExtendedVibrationTable[];
  hasAnySelectedCells: boolean;
  handleCellSelectionChange: (params: {
    description: string;
    columnKey: string;
    value: boolean;
  }) => void;
  handlePeriodChange: (value: string) => void;
  clearSelections: () => void;
  isLoading: boolean;
};

export const AttachVibrationAnalysisTable = ({
  assetId,
  vibrationAnalysisData,
}: {
  assetId: string;
  vibrationAnalysisData: VibrationAnalysisData;
}) => {
  const { t } = useTranslation();

  const { filteredData, hasAnySelectedCells, handleCellSelectionChange, isLoading } =
    vibrationAnalysisData;

  const VibrationAnalysisMutation = useVibrationAnalysisMutation();

  const { columns } = useVibrationAnalysisColumns({
    data: filteredData,
    handleCellSelectionChange,
  });

  const handleSaveClick = () => {
    if (getSelectedVibrationCells(filteredData).length > 0) {
      handleVibrationAnalysisSave(
        getSelectedVibrationCells(filteredData),
        assetId,
        VibrationAnalysisMutation.mutate,
      );
    }
  };

  return (
    <div className="attach-vibration-analysis-table-container">
      {filteredData.length > 0 ? (
        <>
          <Table<ExtendedVibrationTable>
            className="attach-vibration-analysis-table"
            data={filteredData}
            columns={columns}
            style={{}}
          />

          <Tooltip
            title={`${
              !hasAnySelectedCells ? t('monitoring:tables.messages.selectAtLeastOne') : ''
            }`}
          >
            <PrimaryButton
              onClick={handleSaveClick}
              startIcon={<AddCircleOutlineOutlined />}
              disabled={!hasAnySelectedCells || VibrationAnalysisMutation.isLoading}
              className={`${
                !hasAnySelectedCells ? 'attach-btn-disabled' : ''
              } attach-vibration-analysis-btn`}
            >
              {VibrationAnalysisMutation.isLoading
                ? t('monitoring:tables.messages.saving')
                : t('monitoring:tables.messages.addEvidence')}
            </PrimaryButton>
          </Tooltip>
        </>
      ) : (
        <NoData
          i18nKey="monitoring:tables:messages.no_data.VIBRATION_ANALYSIS"
          icon={null}
          isLoading={isLoading}
        />
      )}
    </div>
  );
};
